import Megatron from '@stencil/megatron';
import {prepareGetOffersApiRequest} from './../utils/prepareGetOffersApiRequest';
import {AppState} from './../../../store';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import {updateOffersDataAction, toggleLoadingGetOffersAction} from './actions';
import {IOffersApi} from './types';

export const fetchOffersDataThunk = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(toggleLoadingGetOffersAction(true));
    const url = prepareGetOffersApiRequest();

    Megatron<{}, {success: boolean; data: IOffersApi['data']}>({
      name: 'homePageGetOffersApi',
      type: 'GET',
      credentials: 'same-origin',
      url,
      trackLatency: {timeout: 500, data: {serviceApp: 'avatar', apiTimeout: true}},
    })
      .then(response => {
        dispatch(updateOffersDataAction((response.data || []) as IOffersApi['data']));
        // can we remove toggle loader altogether, still keeping code readable
        dispatch(toggleLoadingGetOffersAction(false));
      })
      .catch(err => {
        dispatch(toggleLoadingGetOffersAction(false));
        // ! do something for error case
      });
    // }
  };
};
